














































import { Component, Vue } from "vue-property-decorator";
import LaporanMatriksHibrida from "@/components/laporan-kebidanan/LaporanMatriksHibrida.vue";
import LaporanKebidananSvc, {
  LayananMatriksHibrida
} from "@/services/LaporanKebidanan";

@Component({
  components: { LaporanMatriksHibrida },
  beforeRouteLeave(to, from, next) {
    const anak = (this as LaporanRl36KebidananPage).$refs.matriks as unknown as {
      bolehDitinggalkan(): boolean;
    };

    if (anak && !anak.bolehDitinggalkan()) {
      next(false);
      return;
    }

    next();
  }
})
export default class LaporanRl36KebidananPage extends Vue {
  readonly layanan: LayananMatriksHibrida = {
    muat: LaporanKebidananSvc.rl36Kebidanan,
    simpan: LaporanKebidananSvc.simpanRl36Kebidanan,
    pdf: LaporanKebidananSvc.pdfRl36Kebidanan,
    excel: LaporanKebidananSvc.excelRl36Kebidanan
  };

  unik(daftar: string[]): string[] {
    return daftar.filter((v, i) => daftar.indexOf(v) === i);
  }
}
